import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, viewChild } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { AoFilterHeaderField } from '../ao-filter-list-header.component';
import { Subject, debounce, debounceTime } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';

/**
 * Popup menu for setting filter option on date columns.
 * It has a date range picker for filtering dates for a specific range.
 * It also allows toggling the sorting order and clearing the filter.
 */
@Component({
    selector: 'app-filter-date-range',
    templateUrl: './filter-date-range.component.html',
    styleUrls: ['./filter-date-range.component.scss'],
    standalone: false,
})
export class FilterDateRangeComponent implements OnInit {
    trigger = viewChild.required(MatMenuTrigger);

    /**
     * The field for which this filter is used
     */
    @Input() field!: AoFilterHeaderField;
    /**
     * The form group with the filter form controls
     */
    @Input() form!: UntypedFormGroup;

    private _filter!: any;
    get filter(): any {
        return this._filter;
    }
    /**
     * The filter value object
     */
    @Input() set filter(value: any) {
        this._filter = value;
        this.setValues();
    }

    /**
     * Emitted when the sorting order changed.
     */
    @Output() sortChange = new EventEmitter<void>();

    /**
     * Unused
     */
    @Output() resetRange = new EventEmitter<void>();

    range = new FormGroup({
        startDate: new FormControl<Date | null>(null),
        endDate: new FormControl<Date | null>(null),
    });

    public dateChangedSub = new Subject<void>();
    public active = false;

    clear(): void {
        this.range.reset();
        this.form.get(this.field.name)?.setValue(this.range.value);
        this.apply();
    }

    ngOnInit(): void {
        this.setValues();
    }

    apply() {
        const startDateControl = this.range.controls.startDate;
        const endDateControl = this.range.controls.endDate;

        const startDate = startDateControl.value;
        const endDate = endDateControl.value;
        if (this.range.valid && startDate && endDate) {
            this.form.get(this.field.name)?.setValue({ startDate, endDate });
        }
        this.active = !!startDateControl.value && !!endDateControl.value;
        this.trigger().closeMenu();
    }

    setValues(): void {
        const val = this.filter[this.field.name];
        if (val) {
            this.range.controls.startDate.setValue(new Date(val.startDate));
            this.range.controls.endDate.setValue(new Date(val.endDate));
        }
    }
}
